import { Navigate, createBrowserRouter } from 'react-router-dom'
import { DrillScreen } from '../features/drill/DrillScreen'
import { HomeScreen } from '../features/home/HomeScreen'
import { ResultScreen } from '../features/result/ResultScreen'
import { SessionRunner } from '../features/session/SessionRunner'
import { AppShell } from './AppShell'
import { RequireAuth } from './RequireAuth'
import { RootLayout } from './RootLayout'
import { RouteError } from './RouteError'
import { paths } from './routes'

/**
 * The student-facing screens are bundled eagerly: a lazily loaded chunk is one
 * more request that can fail offline. Only the diagnostics screen is split
 * out.
 */
export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteError />,
    hydrateFallbackElement: <p className="centered">Načítám…</p>,
    children: [
      {
        element: <RequireAuth />,
        children: [
          {
            element: <AppShell />,
            children: [
              { index: true, element: <HomeScreen /> },
              { path: 'drill/:descriptorId', element: <DrillScreen /> },
              { path: 'session/:sessionId', element: <SessionRunner /> },
              { path: 'result/:sessionId', element: <ResultScreen /> },
              {
                path: 'diagnostics',
                lazy: async () => ({
                  Component: (await import('../features/diagnostics/DiagnosticsScreen')).DiagnosticsScreen,
                }),
              },
              { path: '*', element: <Navigate to={paths.home} replace /> },
            ],
          },
        ],
      },
    ],
  },
])
